<template>
	<div class="summary-card">
		<div class="summary-card__header">
			<h1 class="summary-card__title">{{ appName }}</h1>
			<span
				v-if="tokensOverFree > 0"
				class="summary-card__badge"
				>{{ tokensOverFree }} modules over free tier</span
			>
		</div>

		<p class="summary-card__subtitle">
			Complete full-stack application with {{ moduleCount }} modules
		</p>

		<div class="summary-card__metrics">
			<SummaryMetric
				icon="far fa-clock"
				label="Time Estimate"
				sublabel="Using manual labor"
				:value="
					totalTime.minutes ? `${totalTime.hours}h ${totalTime.minutes}m` : `${totalTime.hours}h`
				" />
			<SummaryMetric
				icon="far fa-dollar-sign"
				label="Market Value"
				sublabel="Using 48€/h average market rate"
				:value="`${totalValue} €`" />
			<SummaryMetric
				icon="far fa-bolt"
				label="Codecannon Price"
				sublabel="With instant delivery"
				:accent="true"
				:value="moduleCount > 5 ? `${moduleCount} tokens` : 'Free'" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SummaryMetric from './SummaryCard/SummaryMetric.vue'

const props = defineProps<{
	appName: string
	totalTime: { hours: number; minutes: number }
	totalValue: string
	moduleCount: number
}>()

const tokensOverFree = computed(() => props.moduleCount - 5)
</script>

<style scoped lang="scss">
.summary-card {
	--card-bg: var(--p-surface-900);
	--border: var(--p-surface-800);
	--muted: var(--p-surface-400);

	container-type: inline-size;
	width: 100%;
	background: var(--p-surface-900);
	border: 1px solid var(--border);
	border-radius: 10px;
	padding: 16px;
	color: var(--p-surface-0);

	.summary-card__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 6px;
	}

	.summary-card__title {
		font-size: 28px;
		font-weight: 700;
	}

	.summary-card__badge {
		background: rgba(238, 255, 1, 0.08);
		border: 1px solid rgba(238, 255, 1, 0.3);
		color: var(--p-yellow-400);
		padding: 6px 10px;
		border-radius: 999px;
		font-size: 12px;
		line-height: 1;
	}

	.summary-card__subtitle {
		margin: 4px 0 14px 0;
		color: var(--muted);
	}

	.summary-card__metrics {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 10px;

		@container (width < 600px) {
			grid-template-columns: 1fr;
		}
	}
}
</style>
